<script lang="ts">
    import { getContext, onMount } from 'svelte'
    import type { Writable } from 'svelte/store'
    import { slide } from 'svelte/transition'

    import { resolveRaw } from 'hydria/services/gettext'
    import { notifications, removeNotificationId } from 'hydria/services/notifications'

    const siContext = getContext('signed-in-context') as Writable<'unknown' | string>
    onMount(() => {
        if ($siContext == null) $siContext = 'unknown'
    })
</script>

<style>
    #notif-container {
        position: fixed;
        top: var(--hy-notif-top-unknown);
        right: var(--hy-notif-right-unknown);
    }
</style>

<aside id="notif-container" class="toast-container {$siContext}" style={`top: var(--hy-notif-top-${$siContext}); right: var(--hy-notif-right-{$siContext});`}>
    {#each $notifications as notif (notif.id)}
        <!-- svelte-ignore a11y_click_events_have_key_events -->
        <!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
        <div transition:slide|local={{ duration: 250 }} class="notification toast show {notif.type ? `text-bg-${notif.type}` : ''} {notif.classes}" onclick={() => removeNotificationId(notif.id)} role="alert" aria-live="assertive" aria-atomic="true">
            <div class="toast-header">
                <div class="me-auto">
                    {#if notif.title}
                        <strong>{$resolveRaw(notif.title)}</strong>
                    {/if}
                </div>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Fermer"
                    onclick={(e) => {
                        e.stopPropagation()
                        removeNotificationId(notif.id)
                    }}
                ></button>
            </div>
            {#if notif.html != null}
                <div class="toast-body">{@html $resolveRaw(notif.html)}</div>
            {:else if notif.text}
                <div class="toast-body">{$resolveRaw(notif.text)}</div>
            {/if}
        </div>
    {/each}
</aside>
